const FormsActionTypes = {
  START_FETCH_FORMS: 'START_FETCH_FORMS',
  FETCH_FORMS_SUCCESS: 'FETCH_FORMS_SUCCESS',
  FETCH_FORMS_FAILURE: 'FETCH_FORMS_FAILURE',
  START_FETCH_APPLICATIONS_FORMS: 'START_FETCH_APPLICATIONS_FORMS',
  FETCH_APPLICATIONS_FORMS_SUCCESS: 'FETCH_APPLICATIONS_FORMS_SUCCESS',
  FETCH_APPLICATIONS_FORMS_FAILURE: 'FETCH_APPLICATIONS_FORMS_FAILURE',
  START_CREATE_FORM: 'START_CREATE_FORM',
  CREATE_FORM_SUCCESS: 'CREATE_FORM_SUCCESS',
  CREATE_FORM_FAILURE: 'CREATE_FORM_FAILURE',
  START_DELETE_FORMS: 'START_DELETE_FORMS',
  DELETE_FORMS_SUCCESS: 'DELETE_FORMS_SUCCESS',
  DELETE_FORMS_FAILURE: 'DELETE_FORMS_FAILURE',
  START_DEACTIVATE_FORM: 'START_DEACTIVATE_FORM',
  DEACTIVATE_FORM_SUCCESS: 'DEACTIVATE_FORM_SUCCESS',
  DEACTIVATE_FORM_FAILURE: 'DEACTIVATE_FORM_FAILURE',
  SEARCH_FORMS: 'SEARCH_FORMS',
  SEARCH_FORMS_BY_STATUS: 'SEARCH_FORMS_BY_STATUS',
  SEARCH_FORMS_RESULTS: 'SEARCH_FORMS_RESULTS',

  FETCH_SINGLE_FORM: 'FETCH_SINGLE_FORM',
  FETCH_SINGLE_FORM_SUCCESS: 'FETCH_SINGLE_FORM_SUCCESS',
  FETCH_SINGLE_FORM_FAILURE: 'FETCH_SINGLE_FORM_FAILURE'
};

export default FormsActionTypes;
